var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0008,
    cy: 20.3216,
    r: 15.3846,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_50929)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0008 4.93701C28.4973 4.93701 35.3854 11.8251 35.3854 20.3216C35.3854 28.8181 28.4973 35.7062 20.0008 35.7062C11.5043 35.7062 4.61621 28.8181 4.61621 20.3216C4.61621 11.8251 11.5043 4.93701 20.0008 4.93701ZM20.0008 6.33561C12.2764 6.33561 6.01481 12.5972 6.01481 20.3216C6.01481 28.0461 12.2764 34.3076 20.0008 34.3076C27.7253 34.3076 33.9868 28.0461 33.9868 20.3216C33.9868 12.5972 27.7253 6.33561 20.0008 6.33561ZM19.5197 9.83212L19.791 10.0139C20.7099 10.6531 23.6372 12.944 23.5127 16.0321C23.4246 17.8335 23.04 18.7006 21.6722 20.3216L21.1225 20.951C20.9043 21.1748 19.3295 22.8839 21.1463 23.993C22.5267 24.8405 26.5449 22.5985 26.3715 18.1132L26.4666 18.1874C26.8302 18.4853 28.1169 19.7356 28.3924 22.5986C28.3924 22.7356 28.3924 22.8727 28.3673 23.0321C28.3673 23.6545 28.2889 24.2629 28.1435 24.8433L28.0232 25.2741L27.9057 25.6013C27.1225 27.6461 25.4582 29.2979 23.3295 30.1692L22.9701 30.309L22.8959 30.33C22.4526 30.4685 22.0344 30.5818 21.5659 30.6741C21.5407 30.6965 21.5169 30.6741 21.4917 30.6741L21.0232 30.7426L20.9994 30.765C20.8268 30.782 20.6538 30.795 20.4805 30.8041L20.2106 30.8111H19.8889C18.2134 30.8111 16.8582 30.3538 15.8232 29.7356C14.9448 29.2836 14.1592 28.6707 13.5071 27.9286L13.1617 27.516L12.9421 27.2223C12.0701 25.9906 11.6041 24.5175 11.6092 23.0083C11.6092 20.6293 12.7673 18.4783 14.591 17.0601L14.6162 17.0377L16.1239 15.8349L17.1435 14.9706C18.3323 13.9342 19.5211 12.6167 19.5211 9.83072L19.5197 9.83212Z",
    fill: "#C80502"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_50929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7692,
    height: 30.7692,
    fill: "white",
    transform: "translate(4.61621 4.93701)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.54d8cb3fe3072fa9b56e8a45bd8c77b0.svg";
export { ForwardRef as ReactComponent };